
import React from 'react'
import { RiHomeLine } from 'react-icons/ri'

const HomeIcon = ({ onClick }) => {
  return (
    <RiHomeLine onClick={onClick} style={{ cursor: 'pointer', width: "20px", height: "20px", color: "gray", margin: "0px 8px 0px 0px" }} />
  )
}

export default HomeIcon